import { PORTKEY_PREFIX_CLS } from '../../../constants';

export const messagePrefixCls = `${PORTKEY_PREFIX_CLS}-message`;

export const notificationPrefixCls = `${PORTKEY_PREFIX_CLS}-notification`;
